import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SelectServiceComponent } from './select-service.component';
import { SelectServiceResolve } from './select-service.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'sign-up/select-service',
        component: SelectServiceComponent,
        resolve: {
          portal: SelectServiceResolve,
        },
      },
      {
        path: 'manage/select-service',
        component: SelectServiceComponent,
        resolve: {
          portal: SelectServiceResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class SelectServiceRoutingModule {}
